<main>
  <section class="upload-profile-photo-container">
    <section class="profile-header">
      <h1>{{ fileUploaded ? "Preview" : title }}</h1>
      <mat-icon (click)="close()">clear</mat-icon>
    </section>
    @if (!fileUploaded) {
      <app-upload-files
        fieldLabel="{{ documentType }}"
        (fileEmitter)="addFile($event)"
      ></app-upload-files>
    }
    @if (fileUploaded && isPictureUpdate()) {
      <section class="profile-photo-container">
        @if (fileUrl) {
          <img
            [src]="fileUrl"
            alt="{{ title }} Preview"
            [ngClass]="{ 'event-photo': isEventPhoto }"
          />
        }
      </section>
    }
    <section class="action-container">
      <button mat-flat-button color="accent" (click)="close()">Cancel</button>
      @if (isPictureUpdate()) {
        <button
          mat-flat-button
          color="primary"
          (click)="fileUploaded ? uploadProfilePhoto() : previewProfilePhoto()"
        >
          {{ fileUploaded ? addImageButton() : ButtonAction.NEXT }}
        </button>
      }
      @if (!isPictureUpdate()) {
        <button
          mat-flat-button
          [disabled]="!file"
          color="primary"
          (click)="upload()"
        >
          {{ ButtonAction.UPLOAD }}
        </button>
      }
    </section>
  </section>
</main>
